var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 5,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5528 8.63035L14.2474 6.82882C14.0855 6.78256 13.9139 6.78256 13.752 6.82882L7.44668 8.63035C7.22224 8.69463 7.03154 8.84354 6.91475 9.04569C6.79797 9.24783 6.76423 9.48743 6.82064 9.71396L7.69438 13.2098V14.9006C7.69438 15.7286 7.85748 16.5485 8.17435 17.3135C8.49122 18.0785 8.95567 18.7736 9.54118 19.3591C10.1267 19.9446 10.8218 20.4091 11.5868 20.7259C12.3518 21.0428 13.1717 21.2059 13.9997 21.2059C14.8278 21.2059 15.6477 21.0428 16.4127 20.7259C17.1777 20.4091 17.8728 19.9446 18.4583 19.3591C19.0438 18.7736 19.5082 18.0785 19.8251 17.3135C20.142 16.5485 20.3051 15.7286 20.3051 14.9006V13.2098L21.1788 9.71487C21.2355 9.4882 21.2019 9.24838 21.0851 9.04603C20.9683 8.84368 20.7774 8.69463 20.5528 8.63035ZM13.9997 8.63125L19.2196 10.1229L18.7017 12.1983H14.9005V10.3967H13.099V12.1983H9.29864L8.7798 10.1229L13.9997 8.63125ZM13.9997 19.4044C12.8057 19.4029 11.6609 18.928 10.8166 18.0837C9.97231 17.2393 9.49734 16.0946 9.49591 14.9006V13.9998H18.5035V14.9006C18.5021 16.0946 18.0271 17.2393 17.1828 18.0837C16.3385 18.928 15.1938 19.4029 13.9997 19.4044Z",
    fill: "#2C3941"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.5ac1105cc52c4c45ec5fa94d695ddae4.svg";
export { ForwardRef as ReactComponent };